import type { Unit, UnitInput } from '@/domain/entities/unit.entity'
import type { UnitDto } from './unit.dto'

export const unitMapper = {
  toUnit(dto: UnitDto): Unit {
    return {
      id: dto.id,
      outletId: dto.outlet_id,
      name: dto.name,
    }
  },

  toBody(input: UnitInput) {
    return { name: input.name.trim() }
  },
}
